import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        // behavior: 'instant' // Removed due to TS error
      });
      // Fallback for older browsers or specific environments
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } catch (error) {
      // Fallback for very old browsers
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop; 